import { Button, createStyles, makeStyles } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import React, { useState } from 'react';
import { SalesTeamMember } from '../../state/salesTeamMember';
import { fetchSalesTeamMemberList } from '../../services/salesTeamMemberService';
import AsyncAutoComplete from './AsyncAutoComplete';
import SalesTeamMemberDialogSearch from './SalesTeamMemberDialogSearch';

interface SalesTeamMemberComboBoxSearchProps {
  handleChange: (result: SalesTeamMember) => void;
  selectedValue: SalesTeamMember;
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  handleClose: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    autoComplete: {
      flexGrow: 20,
    },
    button: {
      marginBottom: '8px',
      flexGrow: 1,
    },
  }),
);

const SalesTeamMemberComboBoxSearch: React.FC<SalesTeamMemberComboBoxSearchProps> = (
  props,
) => {
  const classes = useStyles();
  const { handleChange, selectedValue, isDisabled = false, error, helperText } = props;
  const [openSearch, setOpenSearch] = useState(false);

  const salesTeamMemberPromiseOptions = async (inputValue: string) => {
    const { data: rows } = await fetchSalesTeamMemberList({
      filters: {
        'User.FullNameWithUserName.Contains': inputValue!,
      },
      paging: { pageNumber: 0, pageSize: 10 },
    });
    return rows;
  };

  return (
    <div className={classes.container}>
      <AsyncAutoComplete
        name="SalesTeam Member"
        value={selectedValue}
        className={classes.autoComplete}
        getOptionValue={(option: SalesTeamMember) => {
          return option.id!.toString();
        }}
        getOptionLabel={(option: SalesTeamMember) => {
          return `${option.salesTeam!.name} ${option.user!.fullNameWithUserName!}`;
        }}
        promiseOptions={salesTeamMemberPromiseOptions}
        placeholder={'Type SalesTeam Member Name'}
        handleChange={handleChange}
        isDisabled={isDisabled}
        error={error}
        helperText={helperText}
      />
      <Button
        className={classes.button}
        color="primary"
        variant="outlined"
        startIcon={<Search />}
        disabled={isDisabled}
        onClick={() => {
          setOpenSearch(true);
        }}
        style={{ marginLeft: 10 }}
      >
        Search
      </Button>

      <SalesTeamMemberDialogSearch
        open={openSearch}
        handleClose={(selectedSalesTeamMembers) => {
          if (selectedSalesTeamMembers) {
            handleChange(selectedSalesTeamMembers);
          }
          setOpenSearch(false);
        }}
      />
    </div>
  );
};

export default SalesTeamMemberComboBoxSearch;
